import {Component, OnInit, Input, forwardRef} from '@angular/core';
import {FormGroup, UntypedFormControl, NG_VALUE_ACCESSOR, ControlValueAccessor} from '@angular/forms';
import { filter } from 'rxjs/operators';
import {MaterialPalette, RenderService} from '../../render.service';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-sub-palette-picker',
  templateUrl: './sub-palette-picker.component.html',
  styleUrls: ['./sub-palette-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SubPalettePickerComponent),
      multi: true
    }
  ],
})
export class SubPalettePickerComponent implements OnInit, ControlValueAccessor {

  material: MaterialPalette;

  @Input()
  form = new UntypedFormControl();

  @Input()
  disabled: boolean;

  backdrop: boolean;

  unlocked = new UntypedFormControl(false);

  materialKeys = [...Object.keys(RenderService.MIX_AMOUNTS_PRIMARY), ...Object.keys(RenderService.MIX_AMOUNTS_SECONDARY)];

  private _value: string;
  get value(): string {
    return this._value;
  }

  set value(value: string) {
    this._value = value;
    this.propagateChange(this._value);
  }
  private unregister$ = new Subject();
  private propagateChange = (_) => {};
  private onTouched = () => {};


  registerOnChange(fn: () => void): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: string): void {
    this.form.setValue(obj);
    this.value = obj;
  }

  constructor() {
  }

  get presets() {
    return !this.material ? undefined : this.materialKeys.map(x => this.material[x]);
  }

  ngOnInit() {
    this.form/*.get('main')*/.valueChanges.subscribe(x => {
      if (x) {
        this.value = x;
      }
    });
  }

  getTextColor(col: string) {
    return RenderService.getTextColor(col).startsWith('light') ? '#fff' : '#000';
  }

  setBackdrop(on: boolean) {
    this.backdrop = on;
  }
}
